import React from 'react'
import { Form, FormInstance, Input, Modal, Switch, Tooltip } from 'antd'
import {
  ExclamationCircleOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons'
import { numbersPattern } from 'shared/utils/patterns'
import styles from '../ProductForm.module.scss'

interface IStockFieldsProps {
  form: FormInstance
}

export const StockFields: React.FC<IStockFieldsProps> = ({ form }) => {
  // Отключение списания снимаем только после подтверждения, иначе возвращаем свитч обратно
  const confirmAutoDeductOff = (checked: boolean) => {
    if (checked) {
      return
    }
    Modal.confirm({
      centered: true,
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          <p>
            Автоматическое списание требуется для поддержания актуальных
            остатков в период между синхронизациями с Вашей базой товаров.
          </p>
          <p>
            При отключении автоматического списания остатков покупатели смогут
            заказать товар, который, возможно, уже был продан.
          </p>
          <p style={{ marginBottom: 0 }}>
            Это может понадобиться в том случае, если товар реализуется только
            под заказ и с увеличенным сроком доставки. Действительно хотите
            отключить для данного товара?
          </p>
        </>
      ),
      okText: 'Отключить',
      cancelText: 'Отмена',
      onCancel() {
        form.setFieldValue('auto_deduct_stock', true)
      }
    })
  }

  return (
    <>
      <Form.Item
        name='in_stock'
        label='В наличии (шт.)'
        rules={[
          {
            required: true,
            message: 'Заполните количество товара в штуках'
          },
          {
            pattern: numbersPattern,
            message: 'Заполните количество товара в штуках корректно'
          }
        ]}
        hasFeedback
      >
        <Input placeholder='Количество товара в штуках' />
      </Form.Item>
      <div className={styles.stockSwitches}>
        <div className={styles.stockSwitch}>
          <Form.Item
            name='on_demand'
            valuePropName='checked'
            style={{ marginBottom: 0 }}
          >
            <Switch />
          </Form.Item>
          <span>Под заказ</span>
          <Tooltip title='Даже если товар под заказ, остаток должен быть ненулевым, иначе товар будет скрыт'>
            <QuestionCircleOutlined
              style={{
                fontSize: 16,
                color: 'rgba(0, 0, 0, 0.45)',
                cursor: 'help'
              }}
            />
          </Tooltip>
        </div>
        <div className={styles.stockSwitch}>
          <Form.Item
            name='auto_deduct_stock'
            valuePropName='checked'
            // у нового товара списание включено, у существующего значение придёт из setFields
            initialValue={true}
            style={{ marginBottom: 0 }}
          >
            <Switch onChange={confirmAutoDeductOff} />
          </Form.Item>
          <span>Списывать остатки при покупке</span>
        </div>
      </div>
    </>
  )
}
